
          export const batfishContext = {
            selectedConfig: {
              siteBasePath: '/ekmap-platform-map-flutter',
              siteOrigin: 'https://maplibre.github.io',
              hijackLinks: true,
              manageScrollRestoration: true
            },
            routes: [{
            path: '/ekmap-platform-map-flutter/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-flutter" */
              '/home/duongnv/ekmap-platform-map-flutter/_batfish_tmp/_ekmap-platform-map-flutter.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-flutter/Installation/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-flutter-installation" */
              '/home/duongnv/ekmap-platform-map-flutter/_batfish_tmp/_ekmap-platform-map-flutter_Installation.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-flutter/examples/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-flutter-examples" */
              '/home/duongnv/ekmap-platform-map-flutter/_batfish_tmp/_ekmap-platform-map-flutter_examples.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-flutter/layers/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-flutter-layers" */
              '/home/duongnv/ekmap-platform-map-flutter/_batfish_tmp/_ekmap-platform-map-flutter_layers.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-flutter/layers/line/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-flutter-layers-line" */
              '/home/duongnv/ekmap-platform-map-flutter/_batfish_tmp/_ekmap-platform-map-flutter_layers_line.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-flutter/layers/point/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-flutter-layers-point" */
              '/home/duongnv/ekmap-platform-map-flutter/_batfish_tmp/_ekmap-platform-map-flutter_layers_point.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-flutter/layers/polygon/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-flutter-layers-polygon" */
              '/home/duongnv/ekmap-platform-map-flutter/_batfish_tmp/_ekmap-platform-map-flutter_layers_polygon.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-flutter/maps/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-flutter-maps" */
              '/home/duongnv/ekmap-platform-map-flutter/_batfish_tmp/_ekmap-platform-map-flutter_maps.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-flutter/maps/basemap/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-flutter-maps-basemap" */
              '/home/duongnv/ekmap-platform-map-flutter/_batfish_tmp/_ekmap-platform-map-flutter_maps_basemap.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-flutter/maps/basemap_ctm/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-flutter-maps-basemap-ctm" */
              '/home/duongnv/ekmap-platform-map-flutter/_batfish_tmp/_ekmap-platform-map-flutter_maps_basemap_ctm.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-flutter/maps/bdm/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-flutter-maps-bdm" */
              '/home/duongnv/ekmap-platform-map-flutter/_batfish_tmp/_ekmap-platform-map-flutter_maps_bdm.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-flutter/maps/lum/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-flutter-maps-lum" */
              '/home/duongnv/ekmap-platform-map-flutter/_batfish_tmp/_ekmap-platform-map-flutter_maps_lum.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-flutter/maps/znm/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-flutter-maps-znm" */
              '/home/duongnv/ekmap-platform-map-flutter/_batfish_tmp/_ekmap-platform-map-flutter_maps_znm.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-flutter/marker/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-flutter-marker" */
              '/home/duongnv/ekmap-platform-map-flutter/_batfish_tmp/_ekmap-platform-map-flutter_marker.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-flutter/marker/marker-default/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-flutter-marker-marker-default" */
              '/home/duongnv/ekmap-platform-map-flutter/_batfish_tmp/_ekmap-platform-map-flutter_marker_marker-default.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-flutter/marker/marker-symbol/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-flutter-marker-marker-symbol" */
              '/home/duongnv/ekmap-platform-map-flutter/_batfish_tmp/_ekmap-platform-map-flutter_marker_marker-symbol.js'
            ),
            
            
          },{
            path: '/ekmap-platform-map-flutter/overview/',
            getPage: () => import(
              /* webpackChunkName: "ekmap-platform-map-flutter-overview" */
              '/home/duongnv/ekmap-platform-map-flutter/_batfish_tmp/_ekmap-platform-map-flutter_overview.js'
            ),
            
            
          }],
            notFoundRoute: {
      path: '',
      getPage: () => { throw new Error('No matching route.'); },
      is404: true
    }
          };